export const FormKeyHelper = {
    getChainKey: (formType) => `${formType}Chain`,
    getTokenKey: (formType) => `${formType}Token`,
    getAmountKey: (formType) => `${formType}Amount`,
};
//# sourceMappingURL=types.js.map